import { t } from "./Translate"

export const addCharacterToTabs = (character) => {
	const isTouch = "ontouchstart" in document.documentElement

	const menu = document.querySelector("#characters")

	const tab = document.createElement("li")
	tab.setAttribute("id", character.id)

	if (!isTouch) {
		tab.onmouseenter = () => {
			character.hover()
		}

		tab.onmouseleave = () => {
			character.unhover()
		}
	}

	const selectorButton = document.createElement("button")
	selectorButton.title = t("Select")
	const image = document.createElement("img")
	image.setAttribute("src", character.thumbnail)
	selectorButton.appendChild(image)
	selectorButton.onclick = () => {
		character.selectCharacter()
	}

	const deleteButton = document.createElement("button")
	deleteButton.title = t("Delete (Del)")
	deleteButton.classList.add("tab-delete")
	deleteButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#trash" /></svg>`
	deleteButton.onclick = (event) => {
		character.delete()
		if (menu.firstElementChild) {
			menu.firstElementChild.classList.add("active")
		}
	}

	const flipButton = document.createElement("button")
	flipButton.title = t("Flip (M)")
	flipButton.classList.add("tab-flip")
	flipButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#repeat" /></svg>`
	flipButton.onclick = (event) => {
		character.flip()
	}

	const duplicateButton = document.createElement("button")
	duplicateButton.title = t("Duplicate")
	duplicateButton.classList.add("tab-flip")
	duplicateButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#copy" /></svg>`
	duplicateButton.onclick = (event) => {
		character.duplicate()
	}

	const lockButton = document.createElement("button")
	lockButton.title = t("Lock toggle (K)")
	lockButton.dataset.shortcut = "lock"
	lockButton.classList.add("tab-toggle")
	lockButton.innerHTML = `<svg class="is-active on"><use xlink:href="images/feather-sprite.svg#unlock" /></svg>
        <svg class="off"><use xlink:href="images/feather-sprite.svg#lock" /></svg>`
	lockButton.onclick = (event) => {
		character.toggleJoints()
		if (character.jointsHidden) {
			tab.classList.add("pink")
			lockButton.querySelector(".on").classList.remove("is-active")
			lockButton.querySelector(".off").classList.add("is-active")
		} else {
			tab.classList.remove("pink")
			lockButton.querySelector(".off").classList.remove("is-active")
			lockButton.querySelector(".on").classList.add("is-active")
		}
	}

	const hideButton = document.createElement("button")
	hideButton.title = t("Hide toggle (H)")
	hideButton.dataset.shortcut = "hide"
	hideButton.classList.add("tab-toggle")
	hideButton.innerHTML = `<svg class="is-active on"><use xlink:href="images/feather-sprite.svg#eye" /></svg>
        <svg class="off"><use xlink:href="images/feather-sprite.svg#eye-off" /></svg>`
	hideButton.onclick = (event) => {
		character.toggleVisibility()
		if (!character.object.visible) {
			tab.classList.add("grey")
			hideButton.querySelector(".on").classList.remove("is-active")
			hideButton.querySelector(".off").classList.add("is-active")
		} else {
			tab.classList.remove("grey")
			hideButton.querySelector(".off").classList.remove("is-active")
			hideButton.querySelector(".on").classList.add("is-active")
		}
	}

	const colorSelector = document.createElement("input")
	colorSelector.type = "color"
	colorSelector.classList.add("tab-color")
	colorSelector.value = character.color

	colorSelector.onchange = (event) => {
		character.color = event.target.value
		character.setMaterial()
	}

	const proportionsButton = document.createElement("button")
	proportionsButton.title = t("Adjust proportions")
	proportionsButton.classList.add("tab-flip")
	proportionsButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#sliders" /></svg>`
	proportionsButton.onclick = (event) => {
		character.toggleProportionsPanel()
	}

	const putOnGroundButton = document.createElement("button")
	putOnGroundButton.title = t("Place on ground (G)")
	putOnGroundButton.classList.add("tab-flip")
	putOnGroundButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#chevrons-down" /></svg>`
	putOnGroundButton.onclick = (event) => {
		character.putOnGround()
	}

	const rotationPointButton = document.createElement("button")
	rotationPointButton.title = t("Focus (F)")
	rotationPointButton.classList.add("tab-flip")
	rotationPointButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#target" /></svg>`
	rotationPointButton.onclick = (event) => {
		window.sceneManager.setRotationPoint(character)
	}

	const buttons = [selectorButton, colorSelector]
	if (character.isAdjustable) buttons.push(proportionsButton)
	buttons.push(flipButton, duplicateButton, lockButton, hideButton, putOnGroundButton, rotationPointButton)
	appendButtons(tab, buttons, deleteButton)

	menu.appendChild(tab)
}

// The grid is rtl, so odd positions are the right column. Keep the trash
// bottom right (last when read left to right).
const appendButtons = (tab, buttons, deleteButton) => {
	if (buttons.length % 2) buttons.splice(-1, 0, deleteButton)
	else buttons.push(deleteButton)
	buttons.forEach((button) => {
		addTabTooltip(button)
		tab.appendChild(button)
	})
}

// The tab list clips overflow, so the tooltip lives on body with fixed
// positioning and sits to the right of the hovered button.
let tabTooltip
export const addTabTooltip = (button) => {
	if (!button.title || !window.matchMedia("(hover: hover)").matches) return
	button.addEventListener("mouseenter", () => {
		if (!tabTooltip) {
			tabTooltip = document.createElement("div")
			tabTooltip.classList.add("tooltip", "tab-tooltip")
			document.body.append(tabTooltip)
		}
		const rect = button.getBoundingClientRect()
		tabTooltip.textContent = button.title
		tabTooltip.style.left = `${rect.right + 12}px`
		tabTooltip.style.top = `${rect.top + rect.height / 2}px`
		tabTooltip.style.display = "block"
	})
	button.addEventListener("mouseleave", hideTabTooltip)
	button.addEventListener("click", hideTabTooltip)
}
const hideTabTooltip = () => {
	if (tabTooltip) tabTooltip.style.display = "none"
}

export const addPropToTabs = (prop) => {
	const isTouch = "ontouchstart" in document.documentElement
	const menu = document.querySelector("#characters")

	const tab = document.createElement("li")
	tab.setAttribute("id", prop.id)

	if (!isTouch) {
		tab.onmouseenter = () => {
			prop.hover()
		}
		tab.onmouseleave = () => {
			prop.unhover()
		}
	}

	const selectorButton = document.createElement("button")
	selectorButton.title = t("Select")

	if (prop.icon) {
		selectorButton.innerHTML = `<img src="${prop.icon}" width=20 />`			
	} else {
		selectorButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#${prop.info.icon}" /></svg>`
	}
	
	selectorButton.onclick = () => {
		prop.onTap()
	}

	const colorSelector = document.createElement("input")
	colorSelector.type = "color"
	colorSelector.classList.add("tab-color")
	colorSelector.value = prop.color

	colorSelector.onchange = (event) => {
		prop.color = event.target.value
		prop.setMaterial()
	}

	const duplicateButton = document.createElement("button")
	duplicateButton.title = t("Duplicate")
	duplicateButton.classList.add("tab-flip")
	duplicateButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#copy" /></svg>`
	duplicateButton.onclick = (event) => {
		prop.duplicate()
	}

	const lockButton = document.createElement("button")
	lockButton.title = t("Lock toggle (K)")
	lockButton.dataset.shortcut = "lock"
	lockButton.classList.add("tab-toggle")
	lockButton.innerHTML = `<svg class="is-active on"><use xlink:href="images/feather-sprite.svg#unlock" /></svg>
        <svg class="off"><use xlink:href="images/feather-sprite.svg#lock" /></svg>`
	lockButton.onclick = (event) => {
		prop.toggleLock()
		if (prop.locked) {
			tab.classList.add("pink")
			lockButton.querySelector(".on").classList.remove("is-active")
			lockButton.querySelector(".off").classList.add("is-active")
		} else {
			tab.classList.remove("pink")
			lockButton.querySelector(".off").classList.remove("is-active")
			lockButton.querySelector(".on").classList.add("is-active")
		}
	}

	const hideButton = document.createElement("button")
	hideButton.title = t("Hide toggle (H)")
	hideButton.dataset.shortcut = "hide"
	hideButton.classList.add("tab-toggle")
	hideButton.innerHTML = `<svg class="is-active on"><use xlink:href="images/feather-sprite.svg#eye" /></svg>
        <svg class="off"><use xlink:href="images/feather-sprite.svg#eye-off" /></svg>`
	hideButton.onclick = (event) => {
		prop.toggleVisibility()
		if (!prop.object.visible) {
			tab.classList.add("grey")
			hideButton.querySelector(".on").classList.remove("is-active")
			hideButton.querySelector(".off").classList.add("is-active")
		} else {
			tab.classList.remove("grey")
			hideButton.querySelector(".off").classList.remove("is-active")
			hideButton.querySelector(".on").classList.add("is-active")
		}
	}

	const connectButton = document.createElement("button")
	connectButton.title = t("Attach to character")
	connectButton.classList.add("tab-toggle")
	connectButton.classList.add("attach")
	connectButton.innerHTML = `<svg class="is-active on"><use xlink:href="images/feather-sprite.svg#crosshair" /></svg>
        <svg class="off"><use xlink:href="images/feather-sprite.svg#stop-circle" /></svg>`
	connectButton.onclick = (event) => {
		prop.onSecondaryTap()
	}

	const deleteButton = document.createElement("button")
	deleteButton.title = t("Delete (Del)")
	deleteButton.classList.add("tab-delete")
	deleteButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#trash" /></svg>`
	deleteButton.onclick = (event) => {
		prop.delete()
		if (menu.firstElementChild) {
			menu.firstElementChild.classList.add("active")
		}
	}

	const flipButton = document.createElement("button")
	flipButton.title = t("Flip (M)")
	flipButton.classList.add("tab-flip")
	flipButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#repeat" /></svg>`
	flipButton.onclick = (event) => {
		prop.flip()
	}

	const putOnGroundButton = document.createElement("button")
	putOnGroundButton.title = t("Place on ground (G)")
	putOnGroundButton.classList.add("tab-flip")
	putOnGroundButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#chevrons-down" /></svg>`
	putOnGroundButton.onclick = (event) => {
		prop.putOnGround()
	}

	const rotationPointButton = document.createElement("button")
	rotationPointButton.title = t("Focus (F)")
	rotationPointButton.classList.add("tab-flip")
	rotationPointButton.innerHTML = `<svg viewBox="0 0 24 24"><use xlink:href="images/feather-sprite.svg#target" /></svg>`
	rotationPointButton.onclick = (event) => {
		window.sceneManager.setRotationPoint(prop)
	}

	appendButtons(
		tab,
		[selectorButton, colorSelector, flipButton, duplicateButton, lockButton, hideButton, putOnGroundButton, rotationPointButton, connectButton],
		deleteButton
	)

	menu.appendChild(tab)
}

export const updateTab = (object, action) => {
	const element = document.getElementById(object.id)
	action(element)
}

export const clearCharacterTabs = () => {
	const menu = document.querySelector("#characters")
	menu.innerHTML = ""
}

export const removeFromTabs = (object) => {
	if (document.getElementById(object.id)) {
		document.getElementById(object.id).remove()
	}
}
